export enum AIAnswerAPIType {
	STREAM = 'STREAM',
}
